// export const SERVER_URL = "https://referents-server.vercel.app/api/v1"; // vercel deployed
// export const SERVER_URL = "http://localhost:8080/api/v1"; // local
export const SERVER_URL = "https://referents-346413.uc.r.appspot.com/api/v1";
